export const SUGGESTION_VISIBLE_COUNT = 3
export const SUGGESTION_ITEM_HEIGHT_PX = 72
export const SUGGESTION_LIST_MAX_HEIGHT_PX = SUGGESTION_VISIBLE_COUNT * SUGGESTION_ITEM_HEIGHT_PX

const suggestionListHeightClass = "max-h-[216px]"

export const getSuggestionListClass = (isMobileLayout, preferDropUp = false) => {
  if (isMobileLayout) {
    return `relative z-10 w-full mt-1 bg-white border border-gray-300 rounded-xl shadow-lg ${suggestionListHeightClass} overflow-y-auto`
  }
  if (preferDropUp) {
    return `absolute left-0 right-0 z-[60] w-full mb-1 bottom-full bg-white border border-gray-300 rounded-xl shadow-lg ${suggestionListHeightClass} overflow-y-auto`
  }
  return `absolute left-0 right-0 z-[60] w-full mt-1 top-full bg-white border border-gray-300 rounded-xl shadow-lg ${suggestionListHeightClass} overflow-y-auto`
}

export const getSuggestionItemClass = (isHighlighted) =>
  `px-4 py-2.5 cursor-pointer text-sm border-b border-gray-100 last:border-b-0 transition ${
    isHighlighted ? "bg-blue-50" : "hover:bg-blue-50"
  }`

export const handleSuggestionDropdownKeyDown = (
  e,
  { isOpen, options, highlightIndex, setHighlightIndex, onSelect, onClose, onEnterFallback },
) => {
  if (!isOpen || !options?.length) {
    if (onEnterFallback) onEnterFallback(e)
    return
  }

  if (e.key === "ArrowDown") {
    e.preventDefault()
    setHighlightIndex((prev) => (prev + 1) % options.length)
  } else if (e.key === "ArrowUp") {
    e.preventDefault()
    setHighlightIndex((prev) => (prev <= 0 ? options.length - 1 : prev - 1))
  } else if (e.key === "Enter") {
    e.preventDefault()
    if (highlightIndex > -1 && highlightIndex < options.length) {
      onSelect(options[highlightIndex])
    } else {
      onClose?.()
      onEnterFallback?.(e)
    }
  } else if (e.key === "Escape") {
    e.preventDefault()
    onClose?.()
  }
}

export const scrollHighlightedSuggestionIntoView = (node) => {
  node?.scrollIntoView?.({ block: "nearest" })
}
